import { SuccessPayload } from 'components/widgets/invest-component/storage/invest-states'
import { atomsWithMutation } from 'jotai-tanstack-query'
import { PermitSignStore, getPermitParams } from '../permit-utils'
import { convertAmountToWei } from 'utils'
import { ChainId } from '../interfaces'
import { deployments } from '../deployments'

export const [permitResponseAtom, permitAtom] = atomsWithMutation(() => ({
  mutationKey: ['permit'],
  mutationFn: async (props: SuccessPayload) => {
    const { sellAmount, inputCurrency, account, productAddress, stopProcessing } = props

    const amount = BigInt(convertAmountToWei(sellAmount, inputCurrency.decimals).toFixed())

    if (stopProcessing) stopProcessing()

    const permitParams = await getPermitParams(
      account,
      inputCurrency.chainId as ChainId,
      inputCurrency.address,
      deployments[inputCurrency.chainId][productAddress].Messenger,
      amount,
      inputCurrency.permit,
    )

    return {
      ...permitParams,
      address: inputCurrency.address,
      amount: sellAmount,
    } as PermitSignStore
  },
}))
